<template>
  <div>
    <div id="customer-profile-details" class="vx-row">
      <vx-card>
        <div class="vx-col w-full">

          <ValidationObserver ref="form" v-slot="{ handleSubmit }">
            <form @submit.prevent="handleSubmit(onClickSubmitForm)" autocomplete="off">

              <div class="vx-row mb-3 mt-4">
                <div class="vx-col md:w-1/2 w-full md:mb-0">
                  <small class="label">Client business name</small>
                  <vs-input disabled type="text" name="parent_company_name" class="w-full"
                    v-model="tenant_details.name" />
                </div>
                <div class="vx-col md:w-1/2 w-full md:mb-0">
                  <small class="label">Account No</small>
                  <vs-input disabled type="text" name="company_name" class="w-full"
                    v-model="tenant_details.account_number" />
                </div>
              </div>

              <div class="vx-row mb-3 mt-4">
                <div class="vx-col md:w-1/2 w-full md:mb-0">
                  <small class="label">Partner</small>
                  <vs-input disabled type="text" name="parent_company_name" class="w-full"
                    v-model="tenant_details.partner" />
                </div>
                <div class="vx-col md:w-1/2 w-full md:mb-0">
                  <small class="label">Domain</small>
                  <vs-input disabled type="text" name="parent_company_name" class="w-full"
                    v-model="tenant_details.domain" />
                </div>
              </div>

              <div class="vx-row mb-3 mt-4">
                <div class="vx-col md:w-1/2 w-full md:mb-0">
                  <ValidationProvider vid="first_name" name="first_name" rules="required" v-slot="{ errors }">
                    <small class="label">First Name</small>
                    <vs-input type="text" name="first_name" class="w-full" v-model="tenant_details.first_name"
                      :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather" />
                  </ValidationProvider>
                </div>
                <div class="vx-col md:w-1/2 w-full md:mb-0">
                  <ValidationProvider vid="last_name" name="last_name" rules="required" v-slot="{ errors }">
                    <small class="label">Last Name</small>
                    <vs-input type="text" name="last_name" class="w-full" v-model="tenant_details.last_name"
                      :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather" />
                  </ValidationProvider>
                </div>
              </div>

              <div class="vx-row mb-3 mt-4">
                <div class="vx-col md:w-1/2 w-full md:mb-0">
                  <ValidationProvider vid="email" name="email" rules="required|email" v-slot="{ errors }">
                    <small class="label">Email {{ tenant_details.email_verified_at ? '(verified)' : '' }}</small>

                    <vx-input-group>
                      <vs-input v-model="tenant_details.email" name="email" class="w-full" label=""
                        :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x"
                        val-icon-pack="feather" />
                      <template slot="append">
                        <div v-if="!tenant_details.email_verified_at" style="cursor: pointer"
                          @click="onClickResendWelcomeEmail()" class="prepend-text btn-addon">
                          <vs-button style="border-radius: 0" icon-pack="feather" icon="icon-refresh-cw" type="border"
                            color="primary"></vs-button>
                        </div>
                      </template>
                    </vx-input-group>

                    <!--                    <vs-input type="text" name="email" class="w-full" v-model="tenant_details.email"-->
                    <!--                            :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>-->
                  </ValidationProvider>
                </div>
                <div class="vx-col md:w-1/2 w-full md:mb-0">
                  <ValidationProvider vid="gocardless_id" name="gocardless_id" rules="" v-slot="{ errors }">
                    <small class="label">GoCardless ID</small>

                    <vx-input-group>
                      <vs-input
                        :value="`${tenant_details.gocardless_id.length > 0 ? `${tenant_details.gocardless_id}` : 'not synced'}`"
                        name="email" class="w-full" label="" :danger="!!errors[0]" :danger-text="errors[0]"
                        val-icon-danger="icon-x" val-icon-pack="feather" />
                      <template slot="append">
                        <div v-if="tenant_details.gocardless_id.length === 0" style="cursor: pointer"
                          @click="onClickCreateGoCardLessCustomer()" class="prepend-text btn-addon">
                          <vs-button style="border-radius: 0" icon-pack="feather" icon="icon-refresh-cw" type="border"
                            color="primary"></vs-button>
                        </div>
                      </template>
                    </vx-input-group>
                  </ValidationProvider>
                </div>
              </div>
              <div class="vx-row mb-3 mt-4">
                <div class="vx-col md:w-1/2 w-full md:mb-0">
                  <ValidationProvider vid="trading_currency" name="trading_currency" rules="required"
                    v-slot="{ errors }">
                    <small class="label">Trading urrency</small>
                    <vs-input disabled type="text" name="first_name" class="w-full"
                      v-model="tenant_details.trading_currency" :danger="!!errors[0]" :danger-text="errors[0]"
                      val-icon-danger="icon-x" val-icon-pack="feather" />
                  </ValidationProvider>
                </div>
                <div class="vx-col md:w-1/2 w-full md:mb-0">
                  <ValidationProvider vid="billing_currency" name="billing_currency" rules="required"
                    v-slot="{ errors }">
                    <small class="label">Billing Currency</small>
                    <v-select :clearable="false" label="code" v-model="tenant_details.billing_currency"
                      :reduce="option => option.code" :options="currencyList">
                      <template v-slot:option="option">
                        <span>{{ option.code }} - {{ option.name }} </span>
                      </template>
                    </v-select>
                  </ValidationProvider>
                </div>
              </div>

              <div class="flex flex-wrap items-center justify-end mt-8">
                <vs-button button="submit" class="ml-auto mt-2">Save Changes</vs-button>
              </div>

            </form>
          </ValidationObserver>

        </div>
      </vx-card>
    </div>
  </div>
</template>

<script>
import { RepositoryFactory } from "@/repository/RepositoryFactory";
const TenantRepository = RepositoryFactory.get('tenant')
import ErrorMessages from "@/mixins/ErrorMessages";
const CustomerRepository = RepositoryFactory.get('customer')
const CurrencyRepository = RepositoryFactory.get('currency');
import vSelect from 'vue-select'

export default {
  name: "TenantDetailsView",
  data() {
    return {
      tenant_details: {},
      currencyList: [],
      id: ''
    }
  },
  components: {
    'v-select': vSelect,
  },
  async mounted() {
    this.id = this.$route.params.id
    await this.fetchCountryList()
    await this.fetchTenantDetails()
  },
  mixins: [ErrorMessages],
  methods: {
    async fetchTenantDetails() {
      try {
        const { data } = (await TenantRepository.getTenantDetails(this.id)).data
        this.tenant_details = data
      } catch (e) {
        this.convertAndNotifyError(e)
      }
    },
    async onClickSubmitForm() {
      this.$vs.loading()
      try {
        const payload = {
          first_name: this.tenant_details.first_name,
          last_name: this.tenant_details.last_name,
          email: this.tenant_details.email,
          billing_currency: this.tenant_details.billing_currency
        }
        await TenantRepository.updateTenant(this.id, payload)
        this.showSuccessMessage('Tenant updated successfully')
      } catch (e) {
        this.convertAndNotifyError(e)
      }
      this.$vs.loading.close()
    },
    async onClickResendWelcomeEmail() {
      try {
        await TenantRepository.resendTenantUsersWelcomeEmail(this.tenant_details.email)
        this.showSuccessMessage('Welcome email resent successfully')
      } catch (e) {
        this.convertAndNotifyError(e)
      }
    },
    async onClickCreateGoCardLessCustomer() {
      this.$vs.loading();
      try {
        const payload = {
          tenant_id: this.tenant_details.id,
          params: {
            address_line1: "10 Richard Street",
            address_line2: "Marlow Road",
            address_line3: "",
            city: "Reading",
            company_name: "Sainsbury",
            country_code: "GB",
            email: this.tenant_details.email,
            postal_code: "RG16 7QW"
          }
        }
        await CustomerRepository.createCustomer(payload)
        this.showSuccessMessage('New go cardless customer created')
        await this.fetchTenantDetails()
      } catch (error) {
        this.$vs.loading.close()
        this.convertAndNotifyError(error)
      }
      this.$vs.loading.close()
    },
    async fetchCountryList() {
      const { data } = await CurrencyRepository.getCurrencyList()
      this.currencyList = data.data
    },
  },
}
</script>

<style scoped></style>
